<template>
    <v-dialog v-model="dialog" width="650" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-4">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <div class="font-weight-bold">Email:</div>
                            <div>{{ $store.state.email }}</div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="font-weight-bold">Note: <span class="font-weight-regular">Changing your password may require you to re-login</span></div>
                        </v-col>
                    </v-row>
                    <v-row dense class="mt-3">
                        <v-col v-if="changePassword == false" @click="changePassword = true" cols="12">
                            <v-btn color="red">Change Password</v-btn>
                        </v-col>
                        <v-col v-if="changePassword == true"  cols="12">
                            <v-text-field
                                v-model="oldPassword"
                                :rules="[formRules.required, formRules.noSpacesOnly]"
                                label="Old Password"
                                type="text"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                            ></v-text-field>
                        </v-col>
                        <v-col v-if="changePassword == true"  cols="12">
                            <v-text-field
                                v-model="newPassword"
                                :rules="[formRules.required, formRules.noSpacesOnly, formRules.maxLength]"
                                label="New Password"
                                type="text"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                            ></v-text-field>
                        </v-col>
                        <v-col v-if="changePassword == true"  cols="12">
                            <v-text-field
                                ref="confirmPasswordField"
                                v-model="confirmPassword"
                                :rules="[formRules.required, formRules.noSpacesOnly, formRules.maxLength, formRules.passwordsMatch]"
                                label="Confirm New Password"
                                type="text"
                                variant="outlined"
                                density="comfortable"
                                color="primary"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions v-if="changePassword == true" class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmSave" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to change the password ?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The account will be logged out.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDelete = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="savePassword()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
     emits: ["logout"],
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            oldPassword: null,
            newPassword: null,
            confirmPassword: null,

            changePassword: false,
            confirmSave: false,

            formRules: {
                required: value => !!value || 'Required',
                minValue: value => (value && value != 0) || 'Must be greater than 0',
                maxLength: value => (value && value.toString().length >= 8) || 'Must be less than or equal to 8 characters',
                noSpacesOnly: value => (value && value.trim().length > 0) || 'This cannot be just spaces',
                passwordsMatch: () => this.newPassword === this.confirmPassword || 'Passwords do not match'
            }
        }
     },
     methods: {
        initUpdate(){
            this.dialog = true
            this.dialog_title = 'Update Password'
            this.dialog_sub_title = 'User Profile change password'

            this.changePassword = false
        },
        async validateForm(){
            const { valid } = await this.$refs.form.validate()

            if(valid){
               this.confirmSave = true
            }
        },
        savePassword(){
            const { showSnackbar } = useSnackbar()
            const token = localStorage.getItem('aums-token') 
            let formData = {
                oldPassword: this.oldPassword,
                newPassword: this.newPassword,
                confirmPassword: this.confirmPassword,
                email: this.$store.state.email
            }

            this.loading = true
            axios.post(process.env.VUE_APP_SERVER_URL + '/user-security/updatePassword', formData,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 409){
                    this.loading = false
                    this.confirmSave = false
                    showSnackbar('Old password is incorrect') 
                }
                else if(res.data.status == 400){
                    this.loading = false
                    this.confirmSave = false
                    showSnackbar('There is an error occurred when changing password') 
                }
                if (res.data.status == 200) {
                    this.$emit('logout')
                    this.loading = false
                    this.confirmSave = false
                    showSnackbar('Password Change Successfully .. Logging out..')
                    this.$refs.form.reset()
                    this.dialog = false
                }
                }).catch((error) => {
                if (error.response) {
                    if (error.response.status === 401) {
                            localStorage.removeItem("vuex");
                            localStorage.removeItem("aums-token");
                            window.location.reload();
                    }
                    if (error.response.status === 409){
                        showSnackbar('Old password is not valid')
                        this.loading = false
                    } else {
                        console.log(`Error: ${error.response.status}`);
                    }
                }
            });
        },
        closeDialog(){
            this.$refs.form.reset()
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>